import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchAllManagements,
  addManagement,
  removeManagement,
  updateManagement,
} from '../actions/management.action'
import { Management, UpdateManagementThunkParams } from '@dataTypes/index'

type ManagementState = {
  data: Management[] | null
  loading: boolean
  error: null
}

const initialState: ManagementState = {
  data: null,
  loading: false,
  error: null,
}

const managementsSlice = createSlice({
  name: 'managements',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllManagements.fulfilled,
      (state, action: PayloadAction<Management[]>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchAllManagements.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchAllManagements.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      addManagement.fulfilled,
      (state, action: PayloadAction<Management>) => {
        state.data = state.data
          ? [...state.data, action.payload]
          : [action.payload]
        state.loading = false
      },
    )
    builder.addCase(addManagement.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addManagement.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      updateManagement.fulfilled,
      (state, action: PayloadAction<UpdateManagementThunkParams>) => {
        const { id, body: updatedManagement } = action.payload
        if (!state.data) return
        const index = state.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...updatedManagement }
        }
        state.loading = false
      },
    )
    builder.addCase(updateManagement.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updateManagement.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(removeManagement.fulfilled, (state, action) => {
      const id = action.payload
      if (!state.data) return
      const index = state.data.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.data && state.data.splice(index, 1)
      }
      state.loading = false
    })
    builder.addCase(removeManagement.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removeManagement.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default managementsSlice.reducer
